import type { MixedItemDistResponse } from "@memorang/types";

const fetchStudyPackContents = async (_bundleId: string) => {
	return {
		getMixedItemDistribution: {
			iconUrl: "",
			title: "",
			contents: [],
			freeTagIds: [],
			tags: [],
		} satisfies MixedItemDistResponse,
	};
};

export default fetchStudyPackContents;
